import React from 'react';

export default function QuestionnaireCategoryTitle(props) {
  const {tkey} = props;
  return <h1 style={{textAlign: 'center', paddingTop: 30, paddingBottom: 15}}>{I18n.t(tkey)}</h1>
}